import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let Confirm = class Confirm extends Vue {
    created() {
        console.log(11, this.confirmInfo);
    }
    hide(v) {
        this.close(v);
    }
};
tslib_1.__decorate([
    Prop()
], Confirm.prototype, "close", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], Confirm.prototype, "confirmInfo", void 0);
Confirm = tslib_1.__decorate([
    Component
], Confirm);
export default Confirm;
